/*
 * Copyright (c) SEQTA Software 2018.
 *
 * Created by simon on 2018-06-27
 */

/**
 * Comparator to order numbers by descending order
 * @param a {number}
 * @param b {number}
 * @returns {number}
 */
export const descCompareNumbers = (a, b) => b - a;

/**
 * Turn an array of objects into a map keyed by the given field name.
 * @param arr The array to key
 * @param keyName The property to key by. This is expected to be defined and unique. Will error otherwise.
 * @returns {object} key/value map
 */
export const keyBy = (arr, keyName) => arr && arr.reduce((kv, item) => {
	if (!item || !item[keyName]) throw Error(`Key is null ${keyName} for (${item})`);
	if (kv[item[keyName]]) throw Error(`Duplicate entry for key ${keyName} (${item[keyName]})`);
	kv[item[keyName]] = item;
	return kv;
}, {});


// WEBPACK FOOTER //
// ./src/arrayUtil.js